import { InjectionToken } from '@angular/core';

// ✅ Interface principal
export interface HeroCarouselConfig {
  readonly performance: {
    readonly idleTimeout: number;
    readonly transitionDuration: number;
    readonly preloadSecondaryDelay: number;
  };
  readonly carousel: {
    readonly autoplayInterval: number;
    readonly autoplaySpeed: number;
    readonly showIndicators: boolean;
    readonly showNavigators: boolean;
    readonly circular: boolean;
  };
  readonly error: {
    readonly maxRetryAttempts: number;
    readonly retryDelay: number;
    readonly exponentialBackoff: boolean;
  };
  readonly preload: {
    readonly enabled: boolean;
    readonly priority: 'high' | 'low';
    readonly maxConcurrent: number;
  };
}

// ✅ Configuración por defecto
export const HERO_CAROUSEL_CONFIG: HeroCarouselConfig = {
  performance: {
    idleTimeout: 2000,
    transitionDuration: 300,
    preloadSecondaryDelay: 1000,
  },
  carousel: {
    autoplayInterval: 8000,
    autoplaySpeed: 1000,
    showIndicators: true,
    showNavigators: true,
    circular: true,
  },
  error: {
    maxRetryAttempts: 3,
    retryDelay: 1000,
    exponentialBackoff: true,
  },
  preload: {
    enabled: true,
    priority: 'high',
    maxConcurrent: 2,
  },
} as const;

// ✅ Injection token
export const HERO_CAROUSEL_CONFIG_TOKEN =
  new InjectionToken<HeroCarouselConfig>('HeroCarouselConfig', {
    providedIn: 'root',
    factory: () => HERO_CAROUSEL_CONFIG,
  });
